import _ from 'lodash'
import { createTheme } from '@mui/material/styles'

import { THEME_MODE_DARK } from '../../constants/theme'

import typography from './Typography'
import shadows from './Shadows'
import components from './Override'

const baseTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#00a0e3',
      light: '#e5f7ff',
      dark: '#007eb3',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#d82a90',
      light: '#fbe9f4',
      dark: '#c22480',
      contrastText: '#ffffff'
    },
    success: {
      main: '#00c292',
      light: '#ebfaf2',
      dark: '#00964b',
      contrastText: '#ffffff'
    },
    danger: {
      main: '#e46a76',
      light: '#fdf3f5',
      contrastText: '#ffffff'
    },
    info: {
      main: '#00a0e3',
      light: '#e5f7ff'
    },
    error: {
      main: '#e46a76',
      light: '#fdf3f5',
      dark: '#e45a68'
    },
    warning: {
      main: '#fec90f',
      light: '#fff4e5',
      dark: '#fec90f',
      contrastText: '#ffffff'
    },
    text: {
      secondary: '#777e89',
      danger: '#fc4b6c',
      pink: '#D82A90'
    },
    white: {
      main: '#fff',
      light: '#fff',
      dark: '#fec90f',
      contrastText: '#fec90f'
    },
    custom: {
      white: '#E2E1E4',
      black: '#1D1F25'
    }
  },
  shape: {
    borderRadius: 5
  },
  typography,
  shadows,
  components
}

const DEFAULT_BG_COLOR = '#20232a'

const BuildTheme = () => {
  const mode = THEME_MODE_DARK
  const isDarkMode = true
  const baseMode = {
    palette: {
      mode,
      background: {
        default: isDarkMode ? DEFAULT_BG_COLOR : '#fafbfb',
        dark: isDarkMode ? '#1c2025' : '#ffffff',
        paper: isDarkMode ? '#282C34' : '#ffffff'
      },
      text: {
        primary: isDarkMode ? '#e6e5e8' : 'rgba(0, 0, 0, 0.87)',
        secondary: isDarkMode ? '#adb0bb' : '#777e89'
      },
      inputBorderColor: isDarkMode ? 'rgba(255, 255, 255, 0.12)' : '#dee3e9',
      ssoBorderColor: isDarkMode ? '#42464d' : '#dde3e8'
    }
  }
  const theme = createTheme(_.merge({}, baseTheme, baseMode))
  return theme
}

export { baseTheme, DEFAULT_BG_COLOR, BuildTheme }
